"use client";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import CodeMirror from "~/components/CodeMirror";
import CopyButton from "~/components/CopyButton";

interface Props {
  open: boolean;
  onClose: () => void;
  patches: Record<string, unknown> | null | undefined;
}

export default function LyricsPatchDialog({ open, onClose, patches }: Props) {
  const content = patches ? JSON.stringify(patches, null, 2) : "null";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>JSON Patch</DialogTitle>
      <DialogContent>
        {patches ? (
          <CodeMirror value={content} language="json" readOnly lineWrap />
        ) : (
          <Typography variant="body2">No patches available for this report.</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <CopyButton value={content} title="Copiază patch JSON" />
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  );
}
